var React = require('react');

function Arrow (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"Group_5443","data-name":"Group 5443","transform":"translate(0 28.885) rotate(-90)"},[React.createElement("path",{"id":"Path_43","data-name":"Path 43","d":"M28.178.007,14.088,14.1,0,0","transform":"translate(0 16.662)","fill":"none","stroke":"#fff","strokeMiterlimit":"10","strokeWidth":"2","key":0}),React.createElement("line",{"id":"Line_16","data-name":"Line 16","x1":"0.011","y1":"30.76","transform":"translate(14.077)","fill":"none","stroke":"#fff","strokeMiterlimit":"10","strokeWidth":"2","key":1})]));
}

Arrow.defaultProps = {"width":"32.174","height":"29.592","viewBox":"0 0 32.174 29.592"};

module.exports = Arrow;

Arrow.default = Arrow;
